<script setup lang="ts">
/* eslint-disable max-len */
export interface IconCalendar {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconCalendar>(), { fill: "#A9B7D1", width: 8, height: 8 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.237 0a.678.678 0 0 0-.679.676v1.766c0 .373.305.676.679.676h.174a.678.678 0 0 0 .679-.676V.676A.678.678 0 0 0 3.411 0h-.174zm11.09 1.357h-.374v1.085c0 .654-.534 1.185-1.19 1.185h-.175c-.656 0-1.19-.531-1.19-1.185V1.357H4.602v1.085c0 .654-.534 1.185-1.19 1.185h-.174c-.656 0-1.19-.531-1.19-1.185V1.357h-.375C.75 1.357 0 2.104 0 3.023v11.31C0 15.254.75 16 1.673 16h9.985c.114 0 .22-.032.314-.084a.645.645 0 0 0 .252-.154s3.51-3.553 3.541-3.623a.644.644 0 0 0 .235-.495v-8.62c0-.92-.75-1.667-1.673-1.667zm.37 10.074-.027.028H12.7c-.624 0-1.135.508-1.135 1.13v1.991l-.121.122H1.672c-.2 0-.37-.168-.37-.368V6.315h13.396v5.116zM11.91.676c0-.373.304-.676.679-.676h.174c.374 0 .679.303.679.676v1.766a.678.678 0 0 1-.68.676h-.173a.678.678 0 0 1-.68-.676V.676z" :fill="props.fill" fill-rule="evenodd" />
  </svg>
</template>
